import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ['Querés vender algo rico desde casa pero no sabés por qué producto empezar', 'Ya vendiste alguna vez pero no tenés pedidos fijos ni una forma de conseguirlos', 'Tenés ganas de emprender pero te da miedo invertir y que no salga'];
export function PainSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-charcoal-dark border-y border-white/5" data-id="element-173">
      <div className="max-w-3xl mx-auto text-center" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-175">
          <p className="text-2xl sm:text-3xl md:text-4xl font-bold leading-snug mb-10" data-id="element-176">
            No es que no puedas emprender…{' '}
            <span className="text-gold italic font-normal" data-id="element-177">
              es que nadie te explicó cómo convertir algo simple en dinero.
            </span>
          </p>

          <ul className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-8" data-id="element-178">
            {pains.map((pain, i) => <li key={i} className="flex items-center gap-2.5 text-cream-muted text-lg" data-id="element-179">
                <XCircle className="w-5 h-5 text-red-400/70 flex-shrink-0" data-id="element-180" />
                <span data-id="element-181">{pain}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}